import { Avatar, Box, CircularProgress, Grid, Typography } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../appConstants";
import showToast from "../../../components/Hot-Toast/showToast";
import { jobRoleOnBoardSchema } from "../../../hooks/validationSchema";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { fetchJobRoles } from "../../../utils/commonAPI";
import { useTMutation } from "../../../utils/useTMutation";
import NURSE from "../../../assets/images/big/nurse.png";

const JobTitle = () => {
    const navigate = useNavigate();
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }))
    const dispatch = useDispatch()
    const { data: jobRoles = [], isLoading, isError } = useQuery({
        queryKey: ['jobRoles'],
        queryFn: fetchJobRoles,
        staleTime: 1000 * 60 * 2,
    });
    const { jobData, step } = useSelector(state => state.job)
    console.log("jobData",jobData)
    const { control, handleSubmit, formState: { errors }, watch } = useForm({
        resolver: zodResolver(jobRoleOnBoardSchema),
        defaultValues: {
            JOBROLE_ID: jobData?.JOBROLE_ID || "",

        }
    });
    const onSubmitNext = async (data) => {
        try {
            const response = await mutateAsync({JOBROLE_ID:data.ID, ID: jobData.ID, STEP: jobData.REDIRECT ? 8 : step + 1 });
            if (response.STATUS) {
                if (jobData.REDIRECT) {
                    dispatch(customStep(8))
                } else {
                    dispatch(nextStep())
                }
                dispatch(update({JOB_ROLE_NAME:data?.ROLE_NAME,JOBROLE_ID:data.ID , "REDIRECT": false }))

            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    }
    return (
        <>
            <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={3} pb={3}>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h3" className="about-texts">
                        {/* Job Title */}
                        What Job Role ?
                    </Typography>
                </Grid>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                        <CircularProgress />
                    </Box>
                ) : (

                            <Grid container spacing={3} mt={1} >
                                {jobRoles.map((jobRole) => (
                                    <Grid item lg={4}>
                                        {/* <Avatar
                                            src={jobRole?.IMAGE_NAME ? API_URL + "user/viewFile?fileName=" + jobRole?.IMAGE_NAME : null }
                                            className="avtar"
                                            onClick={()=>onSubmitNext(jobRole)}
                                            sx={{
                                                borderRadius: 5,
                                                width: 120,
                                                height: 80,
                                                border: jobData?.JOBROLE_ID === jobRole.ID ? '2px solid #ff0000' : '3px solid #76c8eb'  , // Change border on selection
                                                transition: 'border-color 0.3s ease', 
                                                cursor: 'pointer', 
                                              }}

                                              
                                        /> */}

                                        <Box display="flex" justifyContent="center">

                                           <img src={NURSE}  alt="image" 
                                             onClick={()=>onSubmitNext(jobRole)}
                                            style={{ 

                                                borderRadius: 20,
                                                width: 120,
                                                height: 80,
                                                border: jobData?.JOBROLE_ID === jobRole.ID ? '2px solid #ff0000' : '3px solid #76c8eb'  , // Change border on selection
                                                transition: 'border-color 0.3s ease', 
                                                cursor: 'pointer', 
                                                objectFit:"cover"
                                            }}
                                            />
                                           </Box>
                                        <Typography style={{paddingTop:"2px" ,textAlign:"center"}}>{jobRole?.ROLE_NAME}</Typography>

                                    </Grid>

                                ))}


                            </Grid>
                   
                )}
                {isError && (
                    <Typography color="error">Failed to load job roles. Please try again later.</Typography>
                )}

            </Grid>

        </>


    )
};

export default JobTitle;


